import { GroupSingle }                                    from './../../../../../models/program/group-single';
import { GroupService }                                   from './../../../group.service';
import { Component, OnInit, Input, Output, EventEmitter,
         OnChanges, SimpleChanges }                       from '@angular/core';
import { Subscription }                                   from 'rxjs/Subscription';

@Component({
  selector: 'app-delete-group-confirm',
  templateUrl: './delete-group-confirm.component.html',
  styleUrls: ['./delete-group-confirm.component.less']
})

export class DeleteGroupConfirmComponent implements OnChanges {
  @Input() groupId: number;
  @Input() programId: number;
  @Output() recall: EventEmitter<boolean> = new EventEmitter<boolean>();
  public group: GroupSingle;
  private request: Subscription;

  constructor(private groupService: GroupService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.groupId) {
      if (this.request) {
        this.request.unsubscribe();
      }
      this.group = null;
      this.request = this.groupService.getGroup(this.programId, this.groupId).subscribe(group => {
        this.group = group;
        this.request.unsubscribe();
      });
    }
  }

  public deleteGroup(): void {
    console.log('Deleting group:', this.group.name, this.group.id, this.programId);
    let body = this.createArr(this.group.id);
    this.groupService.deleteGroup(this.programId, body)
                     .subscribe(() => this.recall.emit(true));
  }

  public noConfirm(): void {
    this.recall.emit(false);
  }

  public createArr(id: number): number[] {
    let arr: number[] = [];
    arr.push(id);
    return arr;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/delete-group-confirm/delete-group-confirm.component.ts